import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//

import repo from '@/api/system-setting/workOrderType';
import * as constants from '@/constants';

/**
 * 选择工单类型下拉组件
 */
export default {
  props: {
    value: {
      type: String | Number,
      default: null
    },
    // 是否允许清除，默认true
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    // 是否初始化下拉选项，默认true
    autoInitOptions: {
      type: Boolean,
      default: true
    },
    // 是否初始化选中，默认false
    autoInitValue: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        this.formData.selectedValue = value;
      }
    },
    // 根据 autoInitValue 判断是否需要默认选中
    dictOptions: {
      immediate: true,
      handler: function handler(val) {
        if (this.autoInitValue) {
          if (val && val.length > 0) {
            this.formData.selectedValue = val[0].value;
            this.onInit(val[0].value);
          }
        }
      }
    }
  },
  data: function data() {
    return {
      dictOptions: [],
      formData: {
        selectedValue: null
      }
    };
  },
  created: function created() {
    if (this.autoInitOptions) {
      this.loadData();
    }
  },
  methods: {
    loadData: function () {
      var _loadData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return repo.loadWorkOrderTypeDict({
                status: constants.ENABLE_STATUS_ON
              }, 'code');
            case 2:
              this.dictOptions = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadData() {
        return _loadData.apply(this, arguments);
      }
      return loadData;
    }(),
    onInit: function onInit(val) {
      this.$emit('input', val);
      this.$emit('init', val);
    },
    onChange: function onChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};